module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedi-side"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction#intro"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_chapterone#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_chapterone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvesting plants")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_chaptertwo#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_chaptertwo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing fabrics")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_chapterthree#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER THREE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_chapterthree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_chapterfour#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER FOUR")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_chapterfour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soya milk")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_chapterfive#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER FIVE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_chapterfive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dyeing basics")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chaptersix#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER SIX")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chaptersix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modifiers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER SEVEN")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPRING")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madder roots")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bay leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nettle tops")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forsythia flowers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spring project")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapterseven#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Linen cushion cover")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER EIGHT")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SUMMER")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buddleja flowers")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goldenrod flowers")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lavender leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woad leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St John’s wort flowers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer project")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chaptereight#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embroidered picnic blanket")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER NINE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AUTUMN")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dahlia flowers")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walnut shells")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elderberries")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dyers chamomile flowers")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yarrow flowers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Autumn project")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapternine#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot water bottle cosy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TEN")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WINTER")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosemary leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivy leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eucalyptus leaves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alder cones")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dyers alkanet roots")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Winter project")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapsub"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapterten#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patchwork quilt")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0